<template>
    <div id="Survey" class="pt-3">
        <b-container class="text-center p-4">
            <b-form @submit.prevent="finishSurvey">
                <expedientecontenido-form-page ref="SurveyForm" buildingURI="survey/prepare"
                    :expedienteVersionId="survey.Usuarioexpediente.expediente_version_id"
                    :usuarioExpedienteId="survey.Usuarioexpediente.id" :hash="getSurveyHashKey" display-submit />
            </b-form>
        </b-container>
        <pre class="text-left" v-if="debug">
            <code>
                {{ getSurveyHashKey }}
            </code>
            <code>
                {{ survey }}
            </code>
        </pre>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex';
import expedientecontenidoFormPage from './Expediente/ExpedientecontenidoFormPage.vue';
import axios from 'axios';
export default {
    name: 'Survey',
    props: {
        debug: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    components: {
        expedientecontenidoFormPage
    },
    data() {
        return {
            form: {}
        };
    },
    computed: {
        ...mapGetters(['getSurvey', 'getSurveyHashKey']),
        isLoaded() {
            return this.getSurvey !== null;
        },
        survey() {
            return (this.getSurvey !== null) ? this.getSurvey : null;
        }
    },
    methods: {
        async finishSurvey($event) {
            if ($event) {
                $event.preventDefault();
            }
            try {
                // Perform any necessary actions to finish the survey
                console.log('Survey finished:', this.survey);
                let form2store = _.clone(this.getSurvey.Usuarioexpediente);
                form2store.answers = this.$refs.SurveyForm.getExpedienteAnswers();
                const response = await axios.post('survey/store/' + this.getSurveyHashKey, form2store)
                if (response.status)
                    // Example: Redirect to a success page
                    this.$router.push({ name: 'SurveyFinished' });
            } catch (error) {
                console.error('Error finishing survey:', error);
            }
        }
    },
    beforeMount() {
        if (!this.isLoaded)
            this.$router.replace({ name: 'NotFound' })
    }
};
</script>

<style lang="scss">
#Survey {
    .nav-pills {
        background-color: #e9ecef;
        min-width: 14vw;
        padding: 0.5em;
        border-radius: 0.5em;
        border: 1px solid #d8d8d8;
    }
}
</style>

<style scoped>
h1 {
    font-size: 2rem;
}
</style>